/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../helpers'
import JumlahPengguna from '../PieChart/JumlahPengguna'
import {JMLPERPUS} from '../../../../api'
import {useEffect, useState} from 'react'
import {executePost} from '../../../../configs/Kubuku'
import {Spinner} from 'react-bootstrap'
import {KTIcon} from '../../../helpers'

type Props = {
  className?: string
  svgIcon?: string
  bgColor?: string
  title?: string
  title2?: number
  jumlah?: number
  loading?: boolean
  iconClass?: string
}

const TilesWidget2 = ({
  className,
  svgIcon,
  iconClass,
  bgColor = '#663259',
  title = 'JUMLAH PERPUSTAKAAN',
  jumlah,
  loading,
}: Props) => {
 

  const formattedJumlah = typeof jumlah === 'number' && !isNaN(jumlah) ? jumlah.toLocaleString('id-ID') : '0';

  
  return (
    <div
      className={clsx('card h-175px bgi-no-repeat bgi-size-contain', className)}
      style={{
        backgroundColor: bgColor,
        backgroundPosition: 'right',
        backgroundImage: `url("${toAbsoluteUrl('/media/svg/misc/taieri.svg')}")`,
      }}
    >
      <div className='card-body d-flex flex-column justify-content-between'>
        <KTIcon iconName={svgIcon || ''} className={clsx(iconClass, 'fs-2hx ms-n1 flex-grow-1')} />
        <h2 className='text-white fw-bold mb-5'></h2>
        <div className='text-white fw-bold mb-5'>
          {loading ? (
            <div className='d-flex align-items-center justify-content-center'>
              <Spinner animation='border' role='status' /> <br />
            </div>
          ) : (
            <>
              <h1 className='text-white'>{formattedJumlah}</h1> {title}{' '}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export {TilesWidget2}
